import $ from 'jquery';

/** Internal dependencies */
import { NCST } from '../';
import YouTubeTrack from '../Support/YouTubeTrack';

export default class VideoController {
	constructor() {
		this.players = [];
		this.embeds = [];
	}

	init() {
		// The ncst-yt-player class system enables the "video image"
		// concept. YouTube requires a unique ID to create the player
		// so we generate that here for the player targets to ensure uniqueness.
		$( '.ncst-yt-player-target' ).each( ( index, trigger ) => {
			$( trigger ).attr( 'id', 'ncst-yt-player-trigger-' + index );
		} );

		$( '.ncst-yt-player-trigger' ).click( this.handleEmededPlayer );

		// Also setup up players for any embeded iframes
		var iframes = document.getElementsByTagName( 'iframe' );
		this.digestPotentialIframes( iframes );

		if ( this.embeds.length > 0 ) {
			this.embeds.forEach( ( video ) => {
				this.createYTPlayer( video );
			} );
		}
	}

	getQueryParam( field, url ) {
		let reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
		let result = reg.exec( url );
		return result ? result[ 1 ] : false;
	}

	async handleEmededPlayer( e ) {
		var { video } = NCST.controllers;
		var $wrapper = $( this ).parents( '.ncst-yt-player' );
		var $target = $wrapper.find( '.ncst-yt-player-target' ).first();

		if ( ! video || ! $wrapper.length || ! $target.length ) {
			return;
		}

		e.preventDefault();

		const player = await video.createYTPlayer(
			$target.attr( 'id' ),
			$( this ).attr( 'href' )
		);

		$wrapper.addClass( 'active' );
		$( this ).fadeOut( 400 );
	}

	/**
	 * Attempts to extract video ID from YouTube URLs. Does not work
	 * if the format uses the 'v' query param and it is not the first
	 * param of the string.
	 *
	 * @param  {string} url YouTube URL
	 * @return {string}     YouTube Video ID
	 */
	extractYTVideoID( url ) {
		var regExp = /^.*((youtu.be\/)|(v\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
		var match = url.match( regExp );
		if ( match && match[ 6 ].length > 0 ) {
			return match[ 6 ];
		}
	}

	extractYTParams( url ) {
		var params = {
			videoID: this.extractYTVideoID( url ),
		};

		var list, listType;

		if ( ( list = this.getQueryParam( 'list', url ) ) ) {
			params.list = list;
		}

		if ( list && ( listType = this.getQueryParam( 'listType', url ) ) ) {
			params.listType = listType;
		}

		return params;
	}

	async ytAPI() {
		var self = this;

		return new Promise( ( resolve ) => {
			if (
				window.YT &&
				window.YT.Player &&
				window.YT.Player instanceof Function
			) {
				resolve( window.YT );

				return;
			} else {
				var tag = document.createElement( 'script' );
				tag.src = 'https://www.youtube.com/iframe_api';
				var firstScriptTag = document.getElementsByTagName(
					'script'
				)[ 0 ];
				firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );
			}

			const cached = window.onYouTubeIframeAPIReady;

			window.onYouTubeIframeAPIReady = () => {
				if ( cached ) {
					cached();
				}

				resolve( window.YT );
			};
		} );
	}

	digestPotentialIframes( potentialVideos ) {
		var i;

		for ( i = 0; i < potentialVideos.length; i++ ) {
			var isYouTubeVideo = this.checkIfYouTubeVideo(
				potentialVideos[ i ]
			);
			if (
				isYouTubeVideo &&
				! potentialVideos[ i ].getAttribute( 'data-ncst-yt-player' )
			) {
				var normalizedYouTubeIframe = this.normalizeYouTubeIframe(
					potentialVideos[ i ]
				);
				this.embeds.push( normalizedYouTubeIframe );
			}
		}
	}

	// Determine if the element is a YouTube video or not
	checkIfYouTubeVideo( potentialYouTubeVideo ) {
		var potentialYouTubeVideoSrc = potentialYouTubeVideo.src || '';

		if (
			potentialYouTubeVideoSrc.indexOf( 'youtube.com/embed/' ) > -1 ||
			potentialYouTubeVideoSrc.indexOf( 'youtube.com/v/' ) > -1
		) {
			return true;
		}

		return false;
	}

	// Turn embed objects into iframe objects and ensure they have the right parameters
	normalizeYouTubeIframe( youTubeVideo ) {
		var a = document.createElement( 'a' );
		a.href = youTubeVideo.src;
		a.hostname = 'www.youtube.com';
		a.protocol = document.location.protocol;
		var tmpPathname =
			a.pathname.charAt( 0 ) === '/' ? a.pathname : '/' + a.pathname; // IE10 shim

		// For security reasons, YouTube wants an origin parameter set that matches our hostname
		var origin =
			window.location.protocol +
			'%2F%2F' +
			window.location.hostname +
			( window.location.port ? ':' + window.location.port : '' );

		if ( a.search.indexOf( 'enablejsapi' ) === -1 ) {
			a.search =
				( a.search.length > 0 ? a.search + '&' : '' ) + 'enablejsapi=1';
		}

		a.pathname = tmpPathname;
		if ( youTubeVideo.src !== a.href + a.hash ) {
			youTubeVideo.src = a.href + a.hash;
		}

		youTubeVideo.setAttribute( 'data-ncst-yt-player', 'true' );

		return youTubeVideo;
	}

	destroyYTPlayer( player ) {
		if ( typeof player === 'string' ) {
			player = this.players[ player ];
		}

		if ( player.getIframe instanceof Function ) {
			const iframe = player.getIframe();
			iframe.remove();
			this.players.splice(
				iframe.getAttribute( 'data-ncst-player-ref' ),
				1
			);
		}
	}

	async createYTPlayer( element, url = '', options = {} ) {
		const YouTube = await this.ytAPI();

		const { videoID, list, listType } = this.extractYTParams( url );

		let player = new YouTube.Player( element, {
			playerVars: {
				rel: 0,
				widget_referrer:
					window.location.protocol +
					'%2F%2F' +
					window.location.hostname,
				...options.playerVars,
			},
			...options,
		} );

		player.addEventListener( 'onReady', ( event ) => {
			if ( list ) {
				event.target.loadPlaylist( { list, listType } );
			} else if ( videoID ) {
				event.target.loadVideoById( videoID );
			}

			event.target
				.getIframe()
				.setAttribute( 'data-ncst-player-ref', this.players.length );
			this.players.push( event.target );
		} );

		player[ 'ncstAnalytics' ] = new YouTubeTrack( player );

		return player;
	}
}
